import { useState } from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from '../auth';

export function LoginPage() {
  const { initialized, login, user } = useAuth();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (!initialized) {
    return (
      <main className="layout">
        <section className="panel">
          <p>Lade Login...</p>
        </section>
      </main>
    );
  }

  if (user) {
    return <Navigate to="/" replace />;
  }

  return (
    <main className="layout public-layout">
      <section className="hero public-head">
        <div className="hero-brand-copy">
          <div className="brand-lockup">
            <img
              className="brand-logo"
              src="/branding/cantabile-logo.png"
              alt="Cantabile Dresden"
            />
            <div>
              <p className="eyebrow">Stimmbildung Orga</p>
              <p className="brand-name">Cantabile Dresden</p>
            </div>
          </div>
          <h1>Login</h1>
        </div>
      </section>

      <section className="panel public-panel" style={{ maxWidth: 480 }}>
        <div className="panel-head public-panel-head">
          <div>
            <h2>Anmeldung</h2>
          </div>
        </div>

        <form
          className="slot-stack"
          onSubmit={(event) => {
            event.preventDefault();

            const formData = new FormData(event.currentTarget);
            const username = String(formData.get('username') ?? '');
            const password = String(formData.get('password') ?? '');

            if (password.trim() === '') {
              setError('Bitte Passwort eingeben.');
              return;
            }

            setBusy(true);
            setError(null);
            login(username, password)
              .catch(() => {
                setError('Benutzername oder Passwort ist ungültig.');
              })
              .finally(() => {
                setBusy(false);
              });
          }}
        >
          <label className="field">
            <span>Benutzername</span>
            <input
              name="username"
              autoComplete="username"
              autoCapitalize="none"
            />
          </label>
          <label className="field">
            <span>Passwort</span>
            <input
              name="password"
              type="password"
              autoComplete="current-password"
            />
          </label>
          <button type="submit" className="button-primary" disabled={busy}>
            Anmelden
          </button>
          {error ? <p className="error-text">{error}</p> : null}
        </form>
      </section>
    </main>
  );
}
